import eventListeners from './event-listeners';
import parentContextClickHandler from '../handlers/parent-context-click-handler';

const parentContextClickListener = (liveDocument) => {
  const parentContextDocument = liveDocument.defaultView.frameElement.ownerDocument;

  eventListeners.add(parentContextDocument, 'click', parentContextClickHandler, true);
};

export default parentContextClickListener;
